module.exports = __webpack_public_path__ + "6f61402415dcf6efdbe6aa14c348e866.svg";